import { Subscriber } from 'rxjs';
import axios from 'axios';

export default class AxiosSubscriber extends Subscriber {
  constructor(observer, axiosConfig, instance) {
    super(observer);

    this.completed = false;
    const fakeAxios = instance ?? axios;
    this.source = axios.CancelToken.source();

    fakeAxios(Object.assign(axiosConfig, { cancelToken: this.source.token }))
      .then((res) => {
        this.completed = true;
        res = axiosConfig.customResponse && axiosConfig.customResponse.success ? axiosConfig.customResponse.success(res) : res;
        observer.next(res);
        observer.complete();
      })
      .catch((err) => {
        this.completed = true;
        if (axios.isCancel(err)) {
          observer.complete();
        } else {
          err = axiosConfig.customResponse && axiosConfig.customResponse.error ? axiosConfig.customResponse.error(err) : err;
          observer.error(err);
        }
      });
  }

  unsubscribe() {
    super.unsubscribe();

    if (!this.completed) {
      this.source.cancel();
      this.completed = true;
    }
  }
}
